<template>
  <ModalHolder :title="''" m-top="120" m-width="40%" m-height="30vh" :is-show="isShow">
    <template slot="mheader">
      <div style="height: 20px;">
        <span style="position:absolute;right:15px;top:15px" @click="dismissModal()">
          <Icon size="20" type="close-circled"></Icon>
        </span>
      </div>
    </template>
    <template slot="mcontent">
      <p v-if="isShow" align="center">
        <Avatar class="member-avatar" :src="userDisplayImage(careteam)"></Avatar>
      </p>
      <h4 align="center">{{careteam.display_name}}</h4>
    </template>
    <template slot="mfooter">
      <Button type="error" style="float: left;" @click="kick()">Remove</Button> 
      <Button type="text" @click="viewProfile()">{{ careteam.user_type == 'member' ? 'Show Profile' : 'Show Organization'}}</Button>
    </template>
  </ModalHolder>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
import Utils from "@/utils.js";

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false
    },
    careteam: {
      required: true,
      default: ""
    }
  },
  methods: {
    viewProfile() {
      this.$emit("showProfile");
    },
    kick() {
      this.$emit("kick");
    },
    dismissModal() {
      this.$emit("close");
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "large");
    }
  },
  components: {
    ModalHolder
  }
};
</script>

<style lang="scss">
.member-avatar {
  margin: 20px 0;
  height: 120px;
  width: 120px;
  img {
    object-fit: cover;
  }
}
</style>

